/* eslint-disable import/no-extraneous-dependencies */

import Admin from 'hive-admin';

import getFilterWithCol from '../../../helpers/getFilterWithCol';

import Types from '../../../modules/types';

const {
  CONTENT_BUILDER_EFFECT: { TYPE_MAP: CBEF_MAP },
} = Types;

const isNotTransform = Admin.compileFromLibrary([
  'condition.testFieldValue',
  'type',
  '!==',
  'TRANSFORM',
]);

const isNotTransformTypeTranslate = Admin.compileFromLibrary([
  'condition.testFieldValue',
  'type',
  '!==',
  'TRANSLATE',
]);

const isNotTransformTypeScale = Admin.compileFromLibrary([
  'condition.testFieldValue',
  'type',
  '!==',
  'SCALE',
]);

const isNotTransformTypeRotate = Admin.compileFromLibrary([
  'condition.testFieldValue',
  'type',
  '!==',
  'ROTATE',
]);

const ITEM_FIELDS = Admin.compileFromLibrary([
  ['FieldHidden', {
    name: 'type',
  }],
  getFilterWithCol(['FieldText', {
    label: null,
    name: 'translate_x',
    prefix: 'X:',
    preSkip: [isNotTransformTypeTranslate],
  }], 12),
  getFilterWithCol(['FieldText', {
    label: null,
    name: 'translate_y',
    prefix: 'Y:',
    preSkip: [isNotTransformTypeTranslate],
  }], 12),
  ['FieldText', {
    label: null,
    name: 'scale_scale',
    prefix: 'Scale:',
    preSkip: [isNotTransformTypeScale],
  }],
  ['FieldText', {
    label: null,
    name: 'rotate_rotate',
    prefix: 'Rotate:',
    preSkip: [isNotTransformTypeRotate],
  }],
], true);

Admin.addToLibrary(
  'FieldContentBuilderEffects:TRANSFORM:ITEM',
  (config = {}) => Admin.compileFromLibrary(['FieldContentBuilderNodes', {
    name: 'transform_items',
    preSkip: [isNotTransform],
    addButtonChoices: CBEF_MAP.TRANSFORM.children.transform_items.TYPE_ITEMS,
    addButtonLabel: 'Add Transform',
    pasteButtonLabel: 'Paste Transform',
    toolbarProps: {
      items: CBEF_MAP.TRANSFORM.children.transform_items.TYPE_ITEMS,
      // eslint-disable-next-line max-len
      itemsLabelsMap: CBEF_MAP.TRANSFORM.children.transform_items.TYPE_LABELS_MAP,
    },
    copyRealm: 'ContentBuilder:Effect:TRANSFORM:transform_items',
    pasteRealm: 'ContentBuilder:Effect:TRANSFORM:transform_items:*',
    targetable: false,
    fields: [
      ...ITEM_FIELDS,
    ],
    nodeType: CBEF_MAP.TRANSFORM.children.transform_items.node,
    ...config,
  }]),
);

export default [
  ...[
    getFilterWithCol(['FieldText', {
      name: 'transform_origin.x',
      label: null,
      prefix: 'Origin X:',
    }], 12),
    getFilterWithCol(['FieldText', {
      name: 'transform_origin.y',
      label: null,
      prefix: 'Origin Y:',
    }], 12),
  ].map(([fieldType, fieldConfig]) => Admin.compileFromLibrary([
    fieldType,
    {
      ...fieldConfig,
      preSkip: [isNotTransform, ...(fieldConfig.preSkip || [])],
    },
  ])),
  ['FieldContentBuilderEffects:TRANSFORM:ITEM', {
    name: 'transform_items',
  }],
];
